module.exports = __webpack_public_path__ + "static/media/first-page-slide4.fee6e5e9.jpg";